"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Personal"] = "Personal";
    OrganizationType["Gym"] = "Gym";
})(OrganizationType || (OrganizationType = {}));
exports.default = OrganizationType;
//# sourceMappingURL=OrganizationType.js.map